module.exports = __webpack_public_path__ + "prod/1.42.2/img/cycle-two.7fbb4780.png";